export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Отчеты: Окончание сроков хранения ЭАД",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
